module.exports = __webpack_public_path__ + "img/CF.fc85711d.svg";